import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserService } from '../../services';
import { InvoiceService } from '../../../invoice';
import { Invoice } from '../../../invoice/models';
import { ClientService } from '../../services/client.service';
import { CompanyService } from '../../services/company.service';
import { CompanyClient } from '../../../shared';
import { User } from '../../models';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kt-app-overview',
  imports: [CommonModule, RouterModule],
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.scss'
})
export class OverviewComponent implements OnInit {
  private userService = inject(UserService);
  private invoiceService = inject(InvoiceService);
  private clientService = inject(ClientService);
  private companyService = inject(CompanyService);

  currentUser = this.userService.currentUser;

  invoices = signal<Invoice[]>([]);
  clients = signal<CompanyClient[]>([]);
  companies = signal<CompanyClient[]>([]);

  activeClientsCount = signal<number>(0);
  inactiveClientsCount = signal<number>(0);
  primaryCompany = signal<CompanyClient | null>(null);

  ngOnInit(): void {
    this.loadOverviewData();
  }

  private isValidUserId(userId: string): boolean {
    return Boolean(userId?.trim());
  }

  private loadOverviewData(): void {
    const activeUser = this.currentUser();
    if (!activeUser || !this.isValidUserId(activeUser.id)) {
      this.invoices.set([]);
      this.clients.set([]);
      this.companies.set([]);
      return;
    }

    this.fetchInvoices(activeUser);
    this.fetchClients(activeUser);
    this.fetchCompanies(activeUser);
  }

  private fetchInvoices(activeUser: User): void {
    this.invoiceService.getInvoicesByUserId(activeUser.id).subscribe({
      next: (res) => {
        this.invoices.set(res);
      },
      error: (error) => {
        console.error('Error fetching invoices:', error);
        this.invoices.set([]);
      }
    });
  }

  private fetchClients(activeUser: User): void {
    this.clientService.getClients(activeUser.id).subscribe({
      next: (res) => {
        this.activeClientsCount.set(res.filter(c => c.isActive).length);
        this.inactiveClientsCount.set(res.filter(c => !c.isActive).length);
        this.clients.set(res);
      },
      error: (error) => {
        console.error('Error fetching clients:', error);
        this.clients.set([]);
      }
    });
  }

  private fetchCompanies(activeUser: User): void {
    this.companyService.getCompanies(activeUser.id).subscribe({
      next: (res) => {
        this.primaryCompany.set(res.find(c => c.isPrimary) || null);

        this.companies.set(res);
      },
      error: (error) => {
        console.error('Error fetching companies:', error);
        this.companies.set([]);
      }
    });
  }
}
